import React from 'react'
import { Button, Icon } from 'react-bulma-components'
import { Link } from 'react-router-dom'
import MissionsFilters from '../../components/missions/filters'
import Protected from '../../components/protected/protected'
import { useMissionsQuery } from '../../queries/missions'
import { MissionAddIcon } from '../../components/icons'
import OrganizationOptionProtected from '../../components/protected/organization-option-protected'
import useFilters from '../../hooks/filters'
import { FiltersResourcesEnum } from '../../store/filters'
import ListPageLayout from '../../components/layout/list-page-layout'
import MissionListTable from '../../components/missions/list'

const MissionsList: React.FunctionComponent = () => {
  const { filters } = useFilters(FiltersResourcesEnum.missions)
  const query = useMissionsQuery({
    ...filters,
    populate: ['user', 'employer', 'interimAgency', 'jobTitle', 'tags', 'service'],
    summary: null,
  })

  const action = (
    <Protected roles={['employerMember']}>
      <OrganizationOptionProtected options={[{ organizationType: 'employer', option: 'biPart' }]}>
        <Button renderAs={Link} to="/missions/new" color="primary" size="small">
          <Icon>
            <MissionAddIcon />
          </Icon>
          <span>Nouvelle Mission Interne</span>
        </Button>
      </OrganizationOptionProtected>
    </Protected>
  )

  return (
    <ListPageLayout
      title="Liste des Missions"
      subtitle="Liste de toutes les missions triées par semaine"
      action={action}
      filters={<MissionsFilters />}
    >
      <MissionListTable missions={query.data || []} />
    </ListPageLayout>
  )
}

export default MissionsList
